import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { Layer, Source } from "react-map-gl";
import Shape from '../interfaces/Shape';
import GeometryService from '../services/geometryService';

function MapShapeLayer({ shapes, color, id }: IMapShapeLayerProps) {
    const geometryService = useMemo(() => new GeometryService(), []);
    const shapeGeoJson: any = useMemo(() => ({
        type: "FeatureCollection",
        features: geometryService.mapIShapesToPolygonFeatures(shapes),
    }), [shapes]);

    return (
        <Source id={`mapShapeSource_${id}`} type="geojson" data={shapeGeoJson}>
            <Layer
                id={`mapShapeLayer_${id}`}
                type="line"
                filter={["==", "$type", "Polygon"]}
                layout={{ "line-cap": "butt", "line-join": "bevel" }}
                paint={{
                    "line-color": color,
                    "line-dasharray": [1, 2],
                    "line-width": 4,
                }}
            />
        </Source>
    );
}

export default observer(MapShapeLayer);

interface IMapShapeLayerProps {
    shapes: Shape[];
    color: string;
    id: string;
}